import React, { lazy, Suspense, useEffect, useState } from 'react'

type LazyComponentProps = {
    componentGetter: Parameters<typeof lazy>[0]
};

export const LazyComponent = (props: LazyComponentProps) => {
  const [Comp, setComp] = useState<any>()

  useEffect(() => {
    if (!Comp) {
      setComp(lazy(props.componentGetter))
    }
  }, [])

  return (
    <Suspense>
      {
        !!Comp && <Comp/>
      }
    </Suspense>
  )
}
